/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import clearIcon from 'Assets/images/commons/search_clear.svg';
import { roundWithTaxPercent } from 'Helpers/utils';
import { CurrencyLabel } from 'Modules/Currency';
import Space from 'Modules/Space';
import {
  getOtterMedicine,
  searchOtterSgProducts,
  withTeleconsultPriceList,
} from 'Redux/modules/webChat/prescription/actions';
import classNames from 'classnames';
import { debounce, upperFirst } from 'lodash';
import { func, shape, string } from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Search } from 'semantic-ui-react';
import { getOtterClinicalTermLabel } from 'Helpers/consult-utils';

import styles from './MedicinePickerField.less';

const PAGE_SIZE_SEARCH_MEDICINE = 30;

const ResultRenderer = ({ name, id, currencySymbol, unitPrice, product }) => {
  const { code, availableQuantity, type } = product || {};
  const isOutOfStock = availableQuantity <= 0;
  const outOfStockText =
    availableQuantity === 0 ? 'Out of stock' : `Out of stock (${availableQuantity})`;

  const isStockValid = !!product?.stockDetails?.length;

  return (
    <div
      className={classNames(styles.searchResultWrapper, { [styles.blur]: !isStockValid })}
      key={id}>
      <div className={styles.searchResults}>
        <div className={styles.resultInfo}>
          <div className={styles.name}>{name}</div>
          <Space direction="horizontal" alignItems="center" size={8}>
            <div className={styles.note}>{upperFirst(type)}</div>
            <div>-</div>
            <div className={styles.note}>Product code: {code}</div>
            <div>-</div>
            <div className={classNames(styles.stock, { [styles.outOfStock]: isOutOfStock })}>
              <Space direction="horizontal" alignItems="center" size={8}>
                {isOutOfStock ? outOfStockText : `${availableQuantity} available`}
              </Space>
            </div>

            {!isStockValid && (
              <>
                <div>-</div>
                <div className={classNames(styles.note, styles.batchUnavailable)}>
                  <Space direction="horizontal" alignItems="center" size={8}>
                    <span>Batch unavailable</span>
                  </Space>
                </div>
              </>
            )}
          </Space>
        </div>
        <div className={styles.currencySymbol}>
          <strong>
            {currencySymbol} <CurrencyLabel value={unitPrice} />
          </strong>
        </div>
      </div>
    </div>
  );
};

ResultRenderer.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  unitPrice: string.isRequired,
  currencySymbol: string.isRequired,
};

const transform = (arr, taxPercent, currencySymbol) => {
  if (!arr?.length) return [];

  return arr.map(item => ({
    id: item.id,
    name: item.name,
    vendor: item?.manufacturer?.name ?? '',
    unitPrice: roundWithTaxPercent(item.sellingPrice, taxPercent),
    unitPriceBeforeTax: item.sellingPrice,
    uom: item.uom,
    Dosage: '',
    taxPercent,
    quantity: item.standardDispensedQuantity ?? 1,
    currencySymbol,
    product: item,
  }));
};

const MedicinePickerField = props => {
  const {
    field: { name, value },
    form: { setFieldValue, values },
    label,
    resultSearchChange,
    pharmacy,
    currencySymbol,
    serviceId,
  } = props;
  const { tenantId } = pharmacy;
  const [currentValue, setCurrentValue] = useState('');

  const dispatch = useDispatch();

  const {
    searchProducts: results,
    status: { searchProducts: statusSearch },
    clinicalTerm,
  } = useSelector(state => state.webChat.prescription);

  const { uom = [] } = clinicalTerm || {};

  const taxPercent = pharmacy?.taxProfile?.taxPercent || 0;

  useEffect(() => {
    if (value) {
      setCurrentValue(value.name);
    }
  }, [value]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (values.mode === 'edit' && values.ottersgProductId && !value.product) {
        const data = await dispatch(
          getOtterMedicine(values.ottersgProductId, withTeleconsultPriceList({}, serviceId)),
        );
        setFieldValue(name, {
          ...value,
          product: data.data,
        });
      }
    };
    fetchProducts();
  }, [
    dispatch,
    name,
    serviceId,
    setFieldValue,
    value,
    values,
    values.mode,
    values.ottersgProductId,
  ]);

  const handleResultSelect = (e, { result }) => {
    if (!result?.product?.stockDetails?.length) {
      return;
    }

    const quantity = result?.product?.standardDispensedQuantity || 1;
    const uomUnit = getOtterClinicalTermLabel(result.uom, uom);
    setFieldValue(name, result);
    setFieldValue('quantity', Math.ceil(+quantity));
    setFieldValue('ottersgProductId', result.id);
    setFieldValue('uomUnit', uomUnit);
    setFieldValue('uomCode', result.uom);
    setCurrentValue(result.name);
  };

  useEffect(() => {
    resultSearchChange(results, currentValue);
  }, [currentValue, resultSearchChange, results]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearchProduct = useCallback(
    debounce(val => {
      if (val)
        dispatch(
          searchOtterSgProducts(
            withTeleconsultPriceList(
              {
                tenantId,
                searchTerm: val,
                type: 'medicine,drug-mixture',
                status: 'active',
                sortType: 'asc',
                page: 1,
                pageSize: PAGE_SIZE_SEARCH_MEDICINE,
              },
              serviceId,
            ),
          ),
        );
    }, 300),
    [dispatch, serviceId, tenantId],
  );

  const handleSearchChange = async (e, { value: val }) => {
    setCurrentValue(val);
    handleSearchProduct(val);
  };

  const clearSearch = () => {
    setCurrentValue('');
    setFieldValue(name, '');
  };

  return (
    <Form.Field className={styles.field}>
      <label htmlFor={name} className={styles.label}>
        {label}
      </label>

      <Search
        fluid
        loading={statusSearch === 0}
        onResultSelect={handleResultSelect}
        onSearchChange={handleSearchChange}
        results={transform(results, taxPercent, currencySymbol)}
        value={currentValue}
        currencySymbol={currencySymbol}
        resultRenderer={renderProps => (
          <ResultRenderer {...renderProps} currencySymbol={currencySymbol} />
        )}
        placeholder="Search medicine"
        noResultsMessage=""
        input={{
          icon: 'search',
          iconPosition: 'left',
          action: (
            <button className={styles.clearSearch} type="button" onClick={clearSearch}>
              <img src={clearIcon} alt="clear" />
            </button>
          ),
          actionPosition: 'right',
        }}
      />
    </Form.Field>
  );
};

MedicinePickerField.defaultProps = {
  pharmacy: null,
};
MedicinePickerField.propTypes = {
  field: shape({}).isRequired,
  resultSearchChange: shape({}).isRequired,
  form: shape({
    setFieldValue: func.isRequired,
    touched: shape({}).isRequired,
  }).isRequired,
  label: string.isRequired,
  pharmacyId: string.isRequired,
  pharmacy: shape({}),
  currencySymbol: string.isRequired,
  serviceId: string,
};

export default MedicinePickerField;
